/**
 * Typed i18n. Each feature defines its messages with `defineMessages(is, en)`; the English
 * object must have exactly the same keys as the Icelandic one (missing key = type error).
 *
 * A message is either a string with `{placeholders}` or a plural form selected with
 * Intl.PluralRules on the `count` variable: { one: '{count} kemur', other: '{count} koma' }.
 * Icelandic CLDR "one" covers 1, 21, 31, … (but not 11).
 */
export type Plural = { one: string; other: string };
export type Msg = string | Plural;

export function defineMessages<const T extends Record<string, Msg>>(is: T, en: { [K in keyof T]: Msg }) {
  return { is, en } as { is: T; en: { [K in keyof T]: Msg } };
}
